export function getTranslationsPage6(postSecondaryInfo, localizedStrings) {
  // Page 6 - postSecondaryInfo
  postSecondaryInfo.postSecondaryInfo.usb_previouslyapplied.elementConfig.label =
    localizedStrings.applicationpage.haveyouappliedusb;
  postSecondaryInfo.postSecondaryInfo.usb_mostrecentpreviousapplicationyear.elementConfig.label =
    localizedStrings.applicationpage.mostrecentyear;

  postSecondaryInfo.postSecondaryInfo.usb_previouslyapplied.elementConfig.options =
    postSecondaryInfo.postSecondaryInfo.usb_previouslyapplied.elementConfig.options.map(
      (option) => {
        if (option.value === true) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.yes,
          };
        } else if (option.value === false) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.no,
          };
        }
        return option;
      },
    );

  // Page 6 - postSecondaryInfoparttwo
  postSecondaryInfo.postSecondaryInfoparttwo.usb_educationlevel.elementConfig.label =
    localizedStrings.applicationpage.educationlevel;
  postSecondaryInfo.postSecondaryInfoparttwo.usb_schooltype.elementConfig.label =
    localizedStrings.applicationpage.schoolincanada;
  postSecondaryInfo.postSecondaryInfoparttwo.usb_secondaryschoolname0.elementConfig.label =
    localizedStrings.applicationpage.selectschoolcanada;
  postSecondaryInfo.postSecondaryInfoparttwo.usb_secondaryschoolname1.elementConfig.label =
    localizedStrings.applicationpage.selectschooloutsidecanada;
  postSecondaryInfo.postSecondaryInfoparttwo.usb_currentdegreestatus.elementConfig.label =
    localizedStrings.applicationpage.currentdegreestatus;

  postSecondaryInfo.postSecondaryInfoparttwo.usb_educationlevel.elementConfig.options =
    postSecondaryInfo.postSecondaryInfoparttwo.usb_educationlevel.elementConfig.options.map(
      (option) => {
        switch (option.value) {
          case 943240000:
            return {
              ...option,
              displayValue: localizedStrings.applicationpage.college,
            };
          case 943240001:
            return {
              ...option,
              displayValue: localizedStrings.applicationpage.university,
            };
          case 943240002:
            return {
              ...option,
              displayValue: localizedStrings.applicationpage.cegep,
            };
          default:
            return option;
        }
      },
    );

  postSecondaryInfo.postSecondaryInfoparttwo.usb_schooltype.elementConfig.options =
    postSecondaryInfo.postSecondaryInfoparttwo.usb_schooltype.elementConfig.options.map(
      (option) => {
        if (option.value === 943240003) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.yes,
          };
        } else if (option.value === 943240004) {
          return {
            ...option,
            displayValue: localizedStrings.applicationpage.no,
          };
        }
        return option;
      },
    );

  postSecondaryInfo.postSecondaryInfoparttwo.usb_currentdegreestatus.elementConfig.options =
    postSecondaryInfo.postSecondaryInfoparttwo.usb_currentdegreestatus.elementConfig.options.map(
      (option) => {
        switch (option.value) {
          case 943240000:
            return {
              ...option,
              displayValue: localizedStrings.applicationpage.currentlystudying,
            };
          case 943240001:
            return {
              ...option,
              displayValue: localizedStrings.applicationpage.graduated,
            };
          case 943240002:
            return {
              ...option,
              displayValue: localizedStrings.applicationpage.nolongerstudying,
            };
          default:
            return option;
        }
      },
    );

  // Page 6 - postSecondaryInfoPartThree
  postSecondaryInfo.postSecondaryInfoPartThree.start_date_month.elementConfig.label =
    localizedStrings.applicationpage.month;
  postSecondaryInfo.postSecondaryInfoPartThree.start_date_year.elementConfig.label =
    localizedStrings.applicationpage.year;

  // Page 6 - postSecondaryInfoPartFour
  postSecondaryInfo.postSecondaryInfoPartFour.end_date_month.elementConfig.label =
    localizedStrings.applicationpage.monthwithoutrequired;
  postSecondaryInfo.postSecondaryInfoPartFour.end_date_year.elementConfig.label =
    localizedStrings.applicationpage.yearwithoutrequired;
  postSecondaryInfo.postSecondaryInfoPartFour.usb_graduationdate.elementConfig.label =
    localizedStrings.applicationpage.graduationyear;
  return postSecondaryInfo;
}
